import { useQuery } from '@tanstack/react-query'
import { getSemestersFromDB } from '@/api/semesters'

/**
 * Custom hook for fetching a list of available semesters from the database.
 * Utilizes the `useQuery` hook from `@tanstack/react-query` for data fetching and caching.
 *
 * This hook supports request cancellation by passing a `signal` to the `getSemestersFromDB` function,
 * which can be used to abort the request if the component unmounts or if a refetch is triggered
 * before the current fetch completes.
 *
 * @returns The result of the `useQuery` call, which includes the status of the query (`isLoading`, `isError`, `isSuccess`),
 *          the data fetched (if successful), and functions to refetch or manipulate the query's state.
 *
 * The `queryKey` is set to ['semesters-list'] to uniquely identify this query in the cache.
 */
const useSemestersList = () => {
   return useQuery({
      queryKey: ['semesters-list'],
      queryFn: ({ signal }) => getSemestersFromDB(signal),
   })
}

export default useSemestersList
